<template>
  <div class="balloon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :viewBox="viewBoxList[balloonType - 1]"
      overflow="visible">
      <template v-if="balloonType === 1">
        <path d="M78.77 155.38c7.56 11.82 14.36 25.54 25.32 34.61 8.31 6.88 25.31 17.37 35.41 8.57 2.49-2.17 1.72-5.23 1.28-8-.71-4.53-4.12-7.39-8.86-6.3-8.14 1.87-5.8 14.51-3.62 19.94 4.13 10.26 16.34 18 25.42 23.34 9.8 5.81 20.29 10.38 30.33 15.75 9.88 5.29 19.23 11.57 26.57 20.14 9.21 10.75 13.74 24.71 16.81 38.28 5 22.26 8.15 48-3.85 68.71-.64 1.1 1.34 3.7.72 4.76 9.86-17 9.15-37 6.41-55.75-2.71-18.63-6-38-16-54.23-10.16-16.47-28-25.21-44.76-33.52a205.17 205.17 0 0 1-23.74-13.23c-8.08-5.45-18.11-13.44-19.89-23.55l.7 4.68c-.23-4.09 1.06-7.68 4.51-10 3.78-2.59 8.91.51 9.8 4.51l-.7-4.68c-.32 6.88-8.57 8.09-14 7.46-7.34-.85-14.6-5.52-20.55-9.6-12.63-8.65-19.94-24-28-36.62.78 1.22-.08 3.51.72 4.76z" :class="`theme-${this.theme}`"/>
        <path
          class="name-bg"
          :class="`theme-${this.theme}`"
          d="M46.18 1.58C12.43 9.75-7.15 47.32 2.43 85.48c13.12 52.22 63.12 72.58 79.57 74.3a11.8 11.8 0 0 0-5.36 4.32 9.37 9.37 0 0 0-.7 8.5 8.27 8.27 0 0 0 6.59-6c.86 2.1 3.12 3.81 5.32 3.25a3.23 3.23 0 0 0 1.89-4.46 13.29 13.29 0 0 0 1.26-.51c2.16.59 4.33 2 6 .65a3.09 3.09 0 0 0 1-2.71 5.88 5.88 0 0 0-4.33-4.67 10.46 10.46 0 0 0-3.81-.32c13.88-9.1 48.24-48.91 34.91-101.94-9.7-38.17-44.84-62.48-78.59-54.31z"/>
        <path d="M11.31 39.34s-.55 1.23-1.26 3.44a55.74 55.74 0 0 0-2.11 9.26c-.29 1.93-.51 4-.62 6.25a65.7 65.7 0 0 0 0 7c.08 2.41.4 4.89.73 7.4s.88 5 1.54 7.53c.31 1.25.63 2.5 1 3.73l.55 1.84.62 1.81c.4 1.21.84 2.4 1.3 3.56l.67 1.74.73 1.7c.93 2.26 2 4.39 2.92 6.43s2 3.93 2.95 5.65l1.36 2.5 1.31 2.23c.81 1.4 1.5 2.64 2.12 3.63 1.21 2 1.86 3.19 1.86 3.19s-1-.92-2.62-2.61a45.12 45.12 0 0 1-2.86-3.15l-1.71-2c-.58-.72-1.15-1.5-1.76-2.31-1.26-1.59-2.48-3.43-3.75-5.38s-2.53-4.09-3.65-6.38l-.88-1.72-.75-1.8-.81-1.82-.72-1.88-.72-1.9-.63-1.95c-.43-1.3-.8-2.62-1.13-4a66.42 66.42 0 0 1-1.5-8.08 58.67 58.67 0 0 1-.36-8 50.35 50.35 0 0 1 .69-7.41 45.23 45.23 0 0 1 1.49-6.47 41.08 41.08 0 0 1 3.88-8.97 21.62 21.62 0 0 1 2.12-3.06z" class="cls-2"/>
        <circle cx="16.1" cy="32.65" r="2" class="cls-3" transform="rotate(-77.23 16.1 32.65)" />
      </template>

      <template v-else-if="balloonType === 2">
        <path d="M67.23 139.81C66 163.18 65.29 188.52 81.87 207c4.63 5.16 9.26 10 13 15.88a176.19 176.19 0 0 1 10.4 19.71 63.59 63.59 0 0 1 3.57 9.53 36.3 36.3 0 0 1 1 4.91c-.79-5.53-.22-1.55-.62.58a83.6 83.6 0 0 0-1.73 15.95c0 11 1.8 20.81 8.94 29.65 3.8 4.7 8.93 7.37 13.79 10.76a17.18 17.18 0 0 1 5.44 6.59 19 19 0 0 1 1.31 4q.45 3.31.33-1-.17 1.44-.46 2.85c-1.26 6.76-4.77 13-7.42 19.31a62.55 62.55 0 0 0-4.61 18.77 99.08 99.08 0 0 0 1.19 28.3 62.48 62.48 0 0 0 16 30.31c-.47-.49 0-4.15 0-4.82s.5-4.24 0-4.82a64.21 64.21 0 0 1-16.28-31.73c-.29-1.42-.48-2.86-.68-4.29s-.14-7.24-.38-2.09a60.21 60.21 0 0 1 1.39-9.83c1.49-7 4.74-13.36 7.53-19.87 4-9.27 4.79-19.37 3.59-29.34-.74-6.19-4.49-10.43-9.55-13.67-5.48-3.51-10-7-13.79-12.47a38.38 38.38 0 0 1-6-15.78c-.75-4.7-.58 4.48 0-.25.21-1.74.63-3.46 1-5.17a48.42 48.42 0 0 0 1.2-9.25 118.07 118.07 0 0 0-.22-12.31c-.64-7.27-4.29-14.16-7.52-20.57A141.37 141.37 0 0 0 92 209c-4.28-6.08-10-11-14.52-16.87-7.59-10-10.85-24.38-10.52-36.73.06-2.09.17-4.19.28-6.28.16-2.9-.15-7 0-9.29z" :class="`theme-${this.theme}`"/>
        <path
          class="name-bg"
          :class="`theme-${this.theme}`"
          d="M60 .05C24.88 1.54-1.92 35 .11 74.7c2.77 54.38 48.37 84.37 64.31 89.3a11.93 11.93 0 0 0-6.16 3.23 9.47 9.47 0 0 0-2.36 8.3 8.37 8.37 0 0 0 7.71-4.65c.44 2.25 2.35 4.39 4.64 4.27a3.27 3.27 0 0 0 2.75-4.06 13.43 13.43 0 0 0 1.35-.26c2 1 3.91 2.82 5.8 1.81a3.13 3.13 0 0 0 1.48-2.5 6 6 0 0 0-3.38-5.48 10.57 10.57 0 0 0-3.72-1.07c15.55-6.31 57.44-39.05 54.63-94.28C125.13 29.57 95-1.44 60 .05z"/>
        <path d="M23.16 24.41s-.92 1-2.3 2.91c-.69 1-1.47 2.13-2.34 3.5a65.42 65.42 0 0 0-5.22 10.54A66.43 66.43 0 0 0 11.1 48c-.68 2.34-1.17 4.82-1.65 7.34s-.75 5.11-.9 7.72c-.1 1.3-.19 2.6-.2 3.9L8.3 69v1.94c0 1.29.05 2.57.12 3.83l.09 1.89.16 1.86c.18 2.46.49 4.84.76 7.1s.64 4.4 1 6.36l.57 2.78.53 2.55c.33 1.6.6 3 .89 4.16.53 2.3.78 3.65.78 3.65s-.65-1.19-1.69-3.34a46.7 46.7 0 0 1-1.75-3.93l-1-2.45c-.32-.87-.62-1.81-1-2.78-.71-1.93-1.29-4.08-1.89-6.36S4.79 81.54 4.43 79l-.3-2-.2-2-.2-2-.1-2-.09-2v-2.07c0-1.38.07-2.77.17-4.16a67.17 67.17 0 0 1 1.12-8.23A59.33 59.33 0 0 1 7 46.75a50.91 50.91 0 0 1 3-6.9 45.74 45.74 0 0 1 3.49-5.74 41.54 41.54 0 0 1 6.64-7.45 21.86 21.86 0 0 1 3.03-2.25z" class="cls-2"/>
        <circle cx="29.88" cy="19.5" r="2.02" class="cls-3" transform="rotate(-58.95 29.88 19.5)"/>
      </template>

      <template v-else-if="balloonType === 3">
        <path d="M44.61 144.35c-7.79 10.8-14.77 22.44-15.78 36-.45 6.07.55 12.91 3.7 18.18 2.26 3.77 8.61 6.1 12 2.43a26.13 26.13 0 0 0 4.29-5.24c3.22-6.09-5.1-9.46-9.6-8.37-6.8 1.65-11.08 11.76-12.09 17.51-2.33 13.22 2.23 26.8 3.13 40 1 14.8-5.65 25.61-13.62 37.41-4 5.86-8.33 11.82-9.46 15a36.19 36.19 0 0 0-2.38 10.52C3.15 321.27-.42 334.43 0 348.14a43.68 43.68 0 0 0 4.09 16.53c1.39 3.08 5.88 12.24 9.79 12a13.73 13.73 0 0 0 3.22-3.58q.27-.68-.48-.82a34.9 34.9 0 0 0-3.22 3.58l-.21.29c.93-1.29 2.29-2.28 3.22-3.58l.21-.29-3.22 3.58q.75.15.48.82l3.22-3.58c-3.38.24-6.87-6.67-8.38-9.23A42.85 42.85 0 0 1 4 350.88c-2-9.53-.15-19.56 1.52-29S6.88 309.64 8.7 301c.66-3.13 3.33-8.36 6.44-13.87 1.74-3.08 3.46-5.18 5.67-9.88 4.28-9.11 11-16.38 12.47-26.57 1.32-9.5-.9-19.3-2.28-28.66-1.33-9-2.2-18.66 1.15-27.34 3.54-9.18 19-1.36 12.38 6.26l3-3.33c-4.73 3.51-9.9.5-12.56-3.94-3.12-5.2-3.26-12.64-2.82-18.49 1-12.79 8.37-24.32 15.67-34.43-.93 1.29-2.29 2.28-3.22 3.58z" :class="`theme-${this.theme}`"/>
        <path
          class="name-bg"
          :class="`theme-${this.theme}`"
          d="M86.2 2.75C53-8 16.39 13.85 4.5 51.61c-16.27 51.67 15.86 95.45 29 105.57a11.87 11.87 0 0 0-6.87.88 9.42 9.42 0 0 0-5.06 6.94 8.32 8.32 0 0 0 8.8-1.67c-.37 2.25.67 4.91 2.85 5.59a3.25 3.25 0 0 0 4-2.83 13.37 13.37 0 0 0 1.35.22c1.54 1.64 2.67 4 4.78 3.7a3.11 3.11 0 0 0 2.25-1.82 5.92 5.92 0 0 0-1.25-6.28 10.52 10.52 0 0 0-3.1-2.29c16.69-.49 67.11-16.5 83.63-69 11.85-37.75-5.46-77.1-38.68-87.87z"/>
        <path d="M51.58 13a32 32 0 0 0-3.63 1.08c-1.13.4-2.47 1-4 1.63s-3.13 1.58-4.86 2.6a62.61 62.61 0 0 0-5.3 3.7 55.85 55.85 0 0 0-5.29 4.84c-.88.88-1.69 1.85-2.54 2.79s-1.65 2-2.4 3l-1.16 1.58-1.07 1.68c-.76 1.08-1.41 2.24-2.09 3.39a92.64 92.64 0 0 0-3.64 7.07c-.55 1.2-1 2.42-1.55 3.6s-.91 2.41-1.38 3.59-.82 2.37-1.23 3.52-.8 2.28-1.1 3.41l-1 3.27-.82 3.09c-.55 2-1 3.82-1.36 5.45s-.74 3.06-1 4.24c-.52 2.36-.87 3.72-.87 3.72s-.07-1.39-.08-3.83v-2c0-.74.07-1.53.11-2.37.09-1.7.17-3.62.46-5.7l.39-3.25.63-3.46c.2-1.19.49-2.4.78-3.64s.59-2.5 1-3.77a73.83 73.83 0 0 1 2.71-7.72 68 68 0 0 1 3.76-7.62c.74-1.22 1.45-2.46 2.29-3.63.4-.59.8-1.18 1.22-1.75l1.31-1.68a48.27 48.27 0 0 1 5.67-6.05 45.81 45.81 0 0 1 6.17-4.69 42.52 42.52 0 0 1 6.12-3.23 36.59 36.59 0 0 1 9.87-2.71 20.17 20.17 0 0 1 3.88-.15z" class="cls-2"/>
        <circle cx="59.83" cy="12.37" r="2.01" class="cls-3" transform="rotate(-27.08 59.83 12.36)"/>
      </template>
    </svg>
    <div
      class="celebrant"
      :class="`celebrant-${balloonType}`">
      <div class="celebrant-text">
         <name-container
            :text="celebrant"
            :chars-limit-one="15"
            :chars-limit-two="18"
            :chars-limit-three="21"
            size-two="0.92em"
            size-three="0.85em" ></name-container>
      </div>
    </div>
  </div>
</template>

<script>
import NameContainer from '@/components/NameContainer.vue'

export default {
  name: 'Balloon',

  props: {
    balloonType: {
      type: Number,
      default: 1
    },
    initialTheme: {
      type: Number,
      default: 0
    },
    celebrant: {
      type: String,
      default: ''
    }
  },

  components: { NameContainer },

  data () {
    return {
      viewBoxList: [
        '0 0 232.48 375.18',
        '0 0 142.24 423.1',
        '0 0 128.59 376.64'
      ],

      counter: 0,
      isReady: false
    }
  },

  computed: {
    theme () {
      return this.counter % 3 + 1
    }
  },

  watch: {
    celebrant (newVal) {
      if (this.isReady) {
        this.counter++
      }
    }
  },

  created () {
    this.counter = this.initialTheme - 1
  },

  mounted () {
    this.isReady = true
  }
}
</script>

<style scoped>
.theme-1{fill:#6ebf4a;}
.theme-2{fill:#59bec9;}
.theme-3{fill:#c800a1;}
.cls-2,
.cls-3{fill:#fff;}
.cls-2{opacity:0.39;}

svg {
  width: 100%;
  height: auto;
}
path {
  transition: fill 0.3s ease-out;
}
.celebrant {
  position: absolute;
  font-family: 'Barlow', sans-serif;
  font-size: 1.5vw;
  text-align: center;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.3;
  font-weight: bold;
}
.celebrant-1 {
  transform: rotate(-13deg);
  top: 8%;
  left: 8%;
  width: 41%;
  height: 22%;
}
.celebrant-2 {
  transform: rotate(-2deg);
  top: 6%;
  left: 11%;
  width: 71%;
  height: 22%;
}
.celebrant-3 {
  transform: rotate(18deg);
  top: 6%;
  left: 15%;
  width: 71%;
  height: 26%;
}
</style>



// WEBPACK FOOTER //
// src/components/BirthdaySlide/Balloon.vue